// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const parcelShopsService = async (data) => {
  return api(`/Sellitback.svc/NearestParcelShops?Postcode=${data.postcode}`,
    {}, 'GET');
};

export default parcelShopsService;
